import React, { useEffect } from "react";
import Banner from "../../components/public/Home/Banner";
import Footer from "../../../src/components/public/Footer";
import Header from "../../components/public/Header";
import TorchEffect from "../../components/torchEffect/TorchEffect";
import HeroSection from "../../components/public/Home/v2/HeroSection";
import ValueProps from "../../components/public/Home/v2/ValueProps";
import MembershipSection from "../../components/public/Home/v2/MembershipSection";
import ClaimSection from "../../components/public/Home/v2/ClaimSection";
import FollowSection from "../../components/public/Home/v2/FollowSection";
import ProofSection from "../../components/public/Home/v2/ProofSection";
import { usePageMeta } from "../../Hooks/usePageMeta";
import "../../styles/home-v2.css";

// TIP-568 — finder-intent title/meta for the directory home only; the rest
// of the site keeps the generic title from public/index.html since there's
// no per-route title elsewhere yet.
const HOME_TITLE = "UAE Business Directory. Find & List Any UAE Business | TREVEX";
const HOME_DESCRIPTION =
  "Search and find any UAE business on TREVEX, the UAE business directory. Every UAE business has a free profile. List and claim yours to be found by buyers.";

const Home = ({ prompt = false }) => {
  usePageMeta({ title: HOME_TITLE, description: HOME_DESCRIPTION, enabled: !prompt });

  useEffect(() => {
    localStorage.setItem("lastVisited", "");
    if (localStorage.getItem("UpgradePlan")) {
      localStorage.removeItem("UpgradePlan");
    }
  }, []);

  // GPT-prompts landing — unchanged legacy layout.
  if (prompt) {
    return (
      <TorchEffect style={{ backgroundColor: "rgba(0,0,0,0.4)", width: "100%" }}>
        <Banner prompt={prompt} />
      </TorchEffect>
    );
  }

  // TIP-518 — redesigned public home page. Global Header/Footer kept as-is;
  // the redesigned body lives under the scoped `.tvx-home` wrapper.
  return (
    <>
      <Header />
      <div className="tvx-home">
        <HeroSection />
        <ValueProps />
        <MembershipSection />
        <ClaimSection />
        <FollowSection />
        <ProofSection />
      </div>
      <Footer />
    </>
  );
};

export default Home;
